"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFabricTextboxObject = exports.FabricTextbox = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var fabric_1 = require("fabric");
var nanoid_1 = require("nanoid");
var fabricObjectUtils_1 = require("../fabricObjectUtils");
var isFabricTextboxObject = function (obj) {
    return (obj === null || obj === void 0 ? void 0 : obj.type) === seesignage_utils_1.ObjectType.CustomTextbox;
};
exports.isFabricTextboxObject = isFabricTextboxObject;
var FabricTextbox = fabric_1.fabric.util.createClass(fabric_1.fabric.Textbox, {
    type: seesignage_utils_1.ObjectType.CustomTextbox,
    initialize: function (customOptions, options, text) {
        if (options === void 0) { options = {}; }
        if (text === void 0) { text = 'Click to add text'; }
        this.callSuper('initialize', text, options);
        this.set({ customOptions: customOptions });
    },
    toObject: function (generalPropertiesToInclude) {
        if (generalPropertiesToInclude === void 0) { generalPropertiesToInclude = [seesignage_utils_1.CanvasSaveMode.toMemory]; }
        var customPropertiesToInclude = ['customOptions', 'text'];
        var propertiesToInclude = __spreadArray(__spreadArray([], generalPropertiesToInclude.slice(1), true), customPropertiesToInclude, true);
        return (0, fabricObjectUtils_1.toObject)(this, propertiesToInclude);
    }
});
exports.FabricTextbox = FabricTextbox;
FabricTextbox.fromObject = function (combinedOptions, callback) {
    var customOptions = combinedOptions.customOptions, text = combinedOptions.text, options = __rest(combinedOptions, ["customOptions", "text"]);
    return callback(new FabricTextbox(customOptions, options, text));
};
window.fabric[seesignage_utils_1.ObjectType.CustomTextbox] = FabricTextbox;
window.fabric.Textbox.fromObject = function (combinedOptions, callback) {
    var _a = combinedOptions.cId, cId = _a === void 0 ? (0, nanoid_1.nanoid)() : _a, options = __rest(combinedOptions, ["cId"]);
    delete options.type;
    delete options.cType;
    return FabricTextbox.fromObject(__assign(__assign({}, options), { customOptions: { id: cId, version: '1.0' } }), callback);
};
//# sourceMappingURL=TextboxObject.js.map